var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNonCustodial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72.928,
    height: 65.081,
    viewBox: "0 0 72.928 65.081",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "non-custodial",
    d: "M-19613.99,3528.729a8.276,8.276,0,0,1-8.283-8.254v-44.439a6.738,6.738,0,0,1,6.742-6.722h30.92l12.361-4.462a2.116,2.116,0,0,1,2.7,1.256l1.172,3.206h5.137a6.738,6.738,0,0,1,6.742,6.722v2.5a6.715,6.715,0,0,1,4.176,1.945,6.656,6.656,0,0,1,1.975,4.752v35.245a8.276,8.276,0,0,1-8.283,8.254Zm-4.023-8.254a4.02,4.02,0,0,0,4.023,4h55.365a4.02,4.02,0,0,0,4.023-4v-35.245a2.487,2.487,0,0,0-2.486-2.477h-58.439a6.471,6.471,0,0,1-2.486-.492Zm52.992-41.967h4.27v-2.472a2.487,2.487,0,0,0-2.486-2.477h-3.59Zm-32.67,0h28.174l-3.279-8.987Zm-20.322-2.472a2.48,2.48,0,0,0,2.486,2.472h5.451l13.705-4.949h-19.156A2.484,2.484,0,0,0-19618.014,3476.037Zm15.359,28.5a9.707,9.707,0,0,1,7.264-10.849,9.707,9.707,0,0,1,11.375,5.742h12.963a2.417,2.417,0,0,1,2.412,2.413v5.18a2.406,2.406,0,0,1-2.412,2.329,2.407,2.407,0,0,1-2.414-2.329v-2.768h-1.625l.006,2.758v.01a2.412,2.412,0,0,1-2.414,2.329,2.41,2.41,0,0,1-2.418-2.329v-2.768h-3.428a9.715,9.715,0,0,1-9.252,8.608c-.145,0-.291,0-.43,0A9.7,9.7,0,0,1-19602.654,3504.535Zm6.225-4.855a4.845,4.845,0,0,0-1.428,3.452,4.862,4.862,0,0,0,1.428,3.452,4.892,4.892,0,0,0,6.9,0,4.893,4.893,0,0,0,0-6.9,4.884,4.884,0,0,0-3.457-1.428A4.868,4.868,0,0,0-19596.43,3499.68Z",
    transform: "translate(19622.773 -3464.149)",
    fill: "#f3bd2f",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonCustodial);
export default __webpack_public_path__ + "static/media/non-custodial.c29f87e4eb9ad4eb74b97de3c62c76ab.svg";
export { ForwardRef as ReactComponent };